import CommonTable, { DataNode, HeaderCells } from "@/components/common/CommonTable";
import { Colors } from "@/enums/Colors";
import NotificationService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/NotificationService";
import { StripePromotionCodeDTO } from "@/models/subscriptions/StripePromotionCodeDTO";
import SubscriptionPurchaseUtilService from "@/services/subscriptions/SubscriptionPurchaseUtilService";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { useEffect, useState } from "react";

const MainContainer = styled(Box)(() => ({
  backgroundColor: "white",
  height: "auto",
  borderRadius: "0 0 0.5rem 0.5rem",
}));

const TableContainer = styled(Box)(() => ({
  padding: "2rem",
  alignItems: "center",
  justifyContent: "center",
  height: "auto",
  width: "auto",
  borderBottom: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
}));

const StyledTypography = styled(Typography)<{ active?: boolean }>(({ active = false }) => ({
  fontSize: "0.75rem",
  fontWeight: active ? "600 !important" : "400",
  color: active ? Colors.BLACK_151517 : Colors.RED,
}));

const headerCells: HeaderCells[] = [
  {
    id: "code",
    label: "Shared Code",
  },
  {
    id: "active",
    label: "Is Active",
  },
  {
    id: "amountOff",
    label: "Amount Off",
  },
  {
    id: "percentOff",
    label: "Percent Off",
  },

  {
    id: "createdAt",
    label: "Created At",
  },
  {
    id: "expiresAt",
    label: "Expires At",
  },
  {
    id: "maxRedemptions",
    label: "Max Redemptions",
  },
  {
    id: "timesRedeemed",
    label: "Times Redeemed",
  },
];

const PARENT_NODE: DataNode = {
  checked: false,
  externalId: "Top Node",
  children: [],
  cells: [],
};

function StripeDiscountsView() {
  const [data, setData] = useState<DataNode>(PARENT_NODE);
  const [promotionCode, setPromotionCode] = useState<StripePromotionCodeDTO[]>([]);

  useEffect(() => {
    fetchData();
  }, []);

  function mapData(promotionCodes: StripePromotionCodeDTO[]) {
    const initializedData: DataNode = {
      ...data,
      children: promotionCodes.map((promotionCode) => ({
        externalId: promotionCode.couponId,
        cells: buildCells(promotionCode),
        checked: false,
        children: [],
      })),
    };
    setData(initializedData);
  }

  function fetchData() {
    SubscriptionPurchaseUtilService.getPromotionCodes().then((r) => {
      r.onSuccess((c) => {
        setPromotionCode(c);
        mapData(c);
      });
      r.onError((_, response) => {
        NotificationService.error(_);
        setData(PARENT_NODE);
      });
    });
  }

  function buildCells(promotionCode: StripePromotionCodeDTO): JSX.Element[] {
    return [
      <StyledTypography active={promotionCode.active} key={promotionCode.code}>
        {promotionCode.code}
      </StyledTypography>,
      <StyledTypography active={promotionCode.active} key={promotionCode.couponId}>
        {promotionCode.active ? "TRUE" : "FALSE"}
      </StyledTypography>,
      <StyledTypography active={promotionCode.active} key={promotionCode.amountOff}>
        {promotionCode.amountOff ? `$ ${promotionCode.amountOff}` : "-"}
      </StyledTypography>,
      <StyledTypography active={promotionCode.active} key={promotionCode.percentOff}>
        {promotionCode.percentOff ? `${promotionCode.percentOff}%` : "-"}
      </StyledTypography>,
      <StyledTypography active={promotionCode.active} key={promotionCode.couponId}>
        {promotionCode?.createdAt ?? "-"}
      </StyledTypography>,
      <StyledTypography active={promotionCode.active} key={promotionCode.couponId}>
        {promotionCode?.expiresAt ?? "-"}
      </StyledTypography>,
      <StyledTypography active={promotionCode.active} key={promotionCode.maxRedemptions}>
        {promotionCode.maxRedemptions ?? "-"}
      </StyledTypography>,
      <StyledTypography active={promotionCode.active} key={promotionCode.timesRedeemed}>
        {promotionCode.timesRedeemed ?? "-"}
      </StyledTypography>,
    ];
  }

  return (
    <>
      <MainContainer>
        <TableContainer>
          <CommonTable hideCheckboxes headerCells={headerCells} setData={setData} data={data} actions={null} />
        </TableContainer>
      </MainContainer>
    </>
  );
}

export default StripeDiscountsView;
